import { Grid2, Paper } from "@mui/material";
import { isLoadingStatus } from "core/actions";
import React from "react";
import FilmCardView, { FilmCardSkeleton } from "./FilmCardView";
function FilmList({ list, maxResults, loadStatus, filmReleaseHistory, filmReleaseHistoryList, ...props }) {
    const loading = isLoadingStatus(loadStatus);
    const items = loading ? (
        <FilmCardSkeletonList maxResults={maxResults} />
    ) : (
        list.map((filmR) => {
            return <FilmListItem key={filmR.id} filmReleaseHistoryList={filmReleaseHistoryList} filmReleaseHistory={filmReleaseHistory} onSelectFilmReleaseHistory={props.onSelectFilmReleaseHistory} filmRelease={filmR} />;
        })
    );

    return (
        <Grid2
            container
            spacing={1}
            style={{ overflow: "auto", maxHeight: "calc(100vh - 230px)", alignContent: "baseline" }}
        >
            {items}
        </Grid2>
    );
}
function FilmCardSkeletonList({ maxResults }) {
    const list = [];
    for (let i = 0; i < maxResults; i++) {
        list.push(
            <Grid2 key={i} size={12}>
                <Paper>
                    <FilmCardSkeleton />
                </Paper>
            </Grid2>
        );
    }
    return list;
}

function FilmListItem({ filmRelease, filmReleaseHistory, filmReleaseHistoryList, onSelectFilmReleaseHistory }) {
    return (
        (<Grid2 size={12}>
            <FilmCardView lazyLoad={false} filmReleaseHistoryList={filmReleaseHistoryList} showHistory={true} filmReleaseHistory={filmReleaseHistory} onSelectFilmReleaseHistory={onSelectFilmReleaseHistory} filmRelease={filmRelease} defaultExpanded={false} listItem />
        </Grid2>)
    );
}
export default FilmList;
